<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h3 class="card-title">City Detail</h3>
      </div>

      <div class="card-body">
        <div class="row">

          <!-- Country -->
          <div class="col-md-4">
            <label>Country</label>
            <select v-model="form.C_CODE" @change="loadProvinces" class="form-control">
              <option value="">Select Country</option>
              <option v-for="c in countries" :key="c.ID" :value="c.ID">
                {{ c.Title }}
              </option>
            </select>
          </div>

          <!-- Province -->
          <div class="col-md-4">
            <label>Province</label>
            <select v-model="form.PVN_ID" class="form-control">
              <option value="">Select Province</option>
              <option v-for="p in provinces" :key="p.ID" :value="p.ID">
                {{ p.Title }}
              </option>
            </select>
          </div>

          <!-- City Name -->
          <div class="col-md-4">
            <label>City Name</label>
            <input type="text" v-model="form.CTY_NAME" class="form-control" />
          </div>

          <!-- Active -->
          <div class="col-md-4 mt-3">
            <label>Active</label><br>
            <input type="checkbox" v-model="form.CTY_ISACTIVE" true-value="Y" false-value="N" />
          </div>

        </div>

        <!-- Buttons -->
        <div class="mt-4">
          <a class="btn btn-primary" href="../UIC/CityList">Back to List</a>
          <button class="btn btn-success float-right mr-1" @click="save">Save</button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      id: 0,
      countries: [],
      provinces: [],
      form: {
        CTY_ID: 0,
        CTY_NAME: "",
        CTY_ISACTIVE: "Y",
        PVN_ID: "",
        C_CODE: ""
      }
    };
  },

  created() {
    const params = new URLSearchParams(window.location.search);
    this.id = parseInt(params.get("id"));

    this.loadCountries();

    if (this.id) {
      this.loadData();
    }
  },

  methods: {

    loadCountries() {
      axios.get("/api/UICApi/getCountry")
        .then(res => {
          this.countries = res.data;
        });
    },

    loadProvinces(selectedProvince = null) {
      this.provinces = [];

      axios.get(`/api/UICApi/getStates?countryId=${this.form.C_CODE}`)
        .then(res => {
          this.provinces = res.data;

          if (selectedProvince) {
            this.form.PVN_ID = selectedProvince;
          }
        });
    },

    loadData() {
      axios.get(`/api/UICApi/getCityById?id=${this.id}`)
        .then(res => {
          if (res.data.status) {
            let data = res.data.data;

            this.form = data;

            this.loadProvinces(data.PVN_ID);

          } else {
            toastr.error(res.data.msg);
          }
        });
    },
    save() {
      axios.post("/api/UICApi/saveCity", this.form)
        .then(res => {
          if (res.data.status) {
            toastr.success("Saved Successfully");
            this.back();
          } else {
            toastr.error(res.data.msg);
          }
        });
    },

    back() {
      window.location.href = "/UIC/CityList";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ims/City.vue